import { SEGMENT_TYPE } from '../constants/radar';

export const transformNode = (node) => {
    const baseNode = {
      id: node.id,
      name: node.name,
      description: node.description || '',
      segmentType: node.segmentType,
    };

    if (node.segmentType === SEGMENT_TYPE.INTERNAL) {
      return {
        ...baseNode,
        internalSegmentId: node.internalSegment?.id,
        color: node.internalSegment?.color || '#4a90e2',
        segmentProcesses: node.segmentProcesses || [],
        subcategories: node.children?.map(transformNode) || []
      };
    } else if (node.segmentType === SEGMENT_TYPE.LEAF) {
      return {
        ...baseNode,
        leafSegmentId: node.leafSegment?.id,
        tags: node.leafSegment?.leafSegmentTags?.map(t => t.tag) || [],
        approvalStage: node.leafSegment?.approvalLevel,
        projects: node.leafSegment?.leafSegmentProjects?.map(p => p.project) || [],
        subcategories: []
      };
    }

    return baseNode;
  };

export const transformApiDataToRadarFormat = (apiData) => {
  if (!apiData || !apiData.length) return null;

  return transformNode(apiData[0]);
};

export const transformToApiFormat = (data, parentSegmentId = null) => {
  const basePayload = {
    name: data.name,
    parentSegmentId,
    description: data.description,
    segmentType: data.segmentType || (data.subcategories?.length > 0 ? SEGMENT_TYPE.INTERNAL : SEGMENT_TYPE.LEAF)
  };

  if (basePayload.segmentType === SEGMENT_TYPE.INTERNAL) {
    return {
      ...basePayload,
      color: data.color
    };
  } else {
    return {
      ...basePayload,
      tags: data.tags?.map(t => t.id) || [],
      projects: data.projects?.map(p => p.id) || []
    };
  }
}; 
